<form [formGroup]="searchBankFormGroup" style="margin-top: 10px">

    <div class="form-field row">
        <p class="form-field-heading col-xs-12">Bank's IFSC</p>
        <mat-form-field class="col-xs-12">
            <input matInput type="text" formControlName="ifscCode" placeholder="Eg : SBIM234567"
                   style="text-transform: uppercase;" autocomplete="off" name="ifsc"
                   title="Please provide a valid IFSC code" (ngModelChange)="clearFieldsForIfsc()">
            <mat-error>{{ getErrorMessage(searchBankFormGroup.controls.ifscCode) }}</mat-error>
            <a mat-button matSuffix class="searchButton"
               (click)="searchBankByIfsc(searchBankFormGroup.controls.ifscCode.value)">Search</a>
        </mat-form-field>
    </div>

    <div class="form-field row">
        <p class="form-field-heading col-xs-12">Bank Name</p>
        <mat-form-field class="col-xs-12">
            <input matInput type="text" formControlName="bankName" [readonly]="true">
        </mat-form-field>
    </div>

    <div class="form-field row">
        <p class="form-field-heading col-xs-12">City</p>
        <mat-form-field class="col-xs-12">
            <input matInput type="text" formControlName="bankCity" [readonly]="true">
        </mat-form-field>
    </div>

    <div class="form-field row">
        <p class="form-field-heading col-xs-12">Bank Branch</p>
        <mat-form-field class="col-xs-12">
            <input matInput type="text" formControlName="bankBranchName" [readonly]="true">
        </mat-form-field>
    </div>

    <div [hidden]="!showAccountDetailsSection">
        <app-bank-account-details [bankAccount]="bankAccount"></app-bank-account-details>
    </div>

</form>
